import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({ selector: '[mwSubForm]' })
export class FormSubFormDirective implements OnInit {
  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'mw-form-sub-form');
  }
}
